import React, { useRef, useState } from "react";
import TableHeader from "../Common/TableHeader";
import { Button } from "@mui/material";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const SpinLoader = () => {
    return (
        <div
            class="spinner-border"
            style={{ width: "1.5rem", height: "1.5rem" }}
            role="status"
        >
            <span style={{display:'none'}} class="sr-only">Loading...</span>
        </div>
    );
};
 
const ImportCandidates = () => {
    const location = useLocation();

    const [file, setFile] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const fileInputRef = useRef();

    console.log("FILE--", file);

    const baseUrl = process.env.REACT_APP_API_PATH;
    const { userResult } = useSelector((state) => state.Auth);
    const vendorId = location?.state?.vendorId ? location?.state?.vendorId : userResult?.vendorid;

    // const handleFileChange = (e) => {
    //     const selectedFile = e.target.files[0];

    //     if (selectedFile) {
    //         // Check if the selected file has a CSV or Excel extension
    //         if (
    //             selectedFile.name.endsWith(".csv") ||
    //             selectedFile.name.endsWith(".xls") ||
    //             selectedFile.name.endsWith(".xlsx")
    //         ) {
    //             setFile(selectedFile);
    //             setError("");
    //         } else {
    //             setFile(null);
    //             setError(
    //                 "Please select a CSV, Excel (.xls), or Excel (.xlsx) file"
    //             );
    //         }
    //     } else {
    //         setFile(null);
    //         setError("");
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (file) {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("vendorId", vendorId);

                const response = await axios.post(
                    `${baseUrl}/ebench/import_candidate`,
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                const data = await response.data;

                setLoading(false);
                console.log("DATAA---", data);

                if (data.data.statusCode === "OK") {
                    toast.success("Candidates Imported Successfully.");
                } else {
                    toast.error(data.status.message);
                }
            } else {
                setLoading(false);
                // Handle the case where no file is selected
                toast.error("Please select a file to upload.");
            }
        } catch (error) {
            setLoading(false);
            console.error("Error uploading the file:", error);
            // Handle other errors that might occur during the upload
            toast.error(error.response.data.status.message);
        }
    };


    const handleImportContainerClick = (e) => {
        fileInputRef.current.click();
        e.stopPropagation();
    };

    return (
        <>
            <ToastContainer />
            <div className='common_wrapper mt-4'>
                <div className="">
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="">
                            <div className="card can_prof_main">
                                <div className="card-header prof_header d-flex justify-content-between">Import Team Members
                                </div>
                                <div className="card-body">
                                    <div
                                        className="import-container common_shadow"
                                    >
                                        <div   onClick={()=>toast.info("Feature Unavailable for now")} className="file-upload">
                                            <label className="custom-file-upload">
                                                <input
                                                    type="file"
                                                    accept=".csv, .xls, .xlsx"
                                                    // onChange={handleFileChange}
                                                    disabled
                                                  
                                                    style={{ display: 'none' }}
                                                    ref={fileInputRef}
                                                />
                                                <span className="common_btn2">Choose CSV File</span>
                                            </label>
                                            {error && <div className="error">{error}</div>}
                                        </div>
                                        {file && <div>File selected: {file.name}</div>}
                                    </div>

                                    <div
                                        className="d-flex align-center mt-4"
                                        style={{ justifyContent: "center" }}
                                    >
                                        <button
                                            type="submit"
                                            // onClick={handleSubmit}
                                            onClick={()=>toast.info("Feature Unavailable for now")}
                                            style={{
                                                width: "100px",
                                                height: "40px",
                                            }}
                                            className="common_btn"
                                        >
                                            {!loading ? "Submit" : <SpinLoader />}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ImportCandidates;
